import { BASE_CHAIN_ID_NUMBER, ETH_CHAIN_ID_NUMBER } from '@mprolab/sdk'
import { getRpcUrlByChainId } from '../utils/getRpcUrl'

export const supportedChainIds = [ETH_CHAIN_ID_NUMBER, BASE_CHAIN_ID_NUMBER].filter(
  (id) => Number.isFinite(id) && id > 0,
)

export const isSupportedChainId = (chainId: number): boolean => {
  return supportedChainIds.includes(chainId)
}

export const getRpc = (): {
  [chainId: number]: string | string[]
} => {
  const rpc: { [chainId: number]: string | string[] } = {}
  supportedChainIds.forEach((chainId) => {
    rpc[chainId] = [getRpcUrlByChainId(chainId)]
  })
  return rpc
}
